import { getWorkSheetHeight } from '../../utils/workSheetHelper';

export default lastColumn => workSheet => {
  const range = workSheet['!ref'];
  const height = getWorkSheetHeight(range);
  const columnRange = `A2:${lastColumn}${height}`;

  return columnRange;
};
